<template>

    <v-page-body>
        <v-section-banner :company="company" />
        <v-section-usage :company="company" />
        <v-section-plans v-if="plans" :plans="plans" @changed="reload" />
        <v-section-subscription v-if="subscription" :subscription="subscription" @changed="reload" />
        <v-section-billing v-if="card" :company="company" :card="card" @changed="reload" />
        <v-section-invoices v-if="invoices.length" :invoices="invoices" />
    </v-page-body>

</template>

<script>

import axios from 'axios';
import BillingApi from '@api/BillingApi';
import CompanyApi from '@api/CompanyApi';
import SectionBilling from './components/SectionBilling';
import SectionInvoices from './components/SectionInvoices';
import SectionBanner from './components/SectionBanner';
import SectionPlans from './components/SectionPlans';
import SectionSubscription from './components/SectionSubscription';
import SectionUsage from './components/SectionUsage';

export default {

    components: {
        'v-section-billing': SectionBilling,
        'v-section-invoices': SectionInvoices,
        'v-section-banner': SectionBanner,
        'v-section-plans': SectionPlans,
        'v-section-subscription': SectionSubscription,
        'v-section-usage': SectionUsage,
    },

    data() {
        return {
            company: null,
            plans: null,
            subscription: null,
            card: null,
            invoices: [],
        }
    },

    mounted() {
        this.reload();
    },

    methods: {

        reload() {
            this.$store.commit('loading', true);
            let requests = [
                CompanyApi.getCompany(this.$store.getters.company.id),
                BillingApi.getPlans(),
                CompanyApi.getSubscription(this.$store.getters.company.id),
            ];
            axios.all(requests)
                .then(axios.spread((resCompany, resPlans, resSubscription) => {
                    this.$store.commit('loading', false);
                    this.company = resCompany.data.data;
                    this.plans = resPlans.data.data;
                    this.subscription = resSubscription.data.data.subscription;
                    this.card = resSubscription.data.data.card;
                    this.invoices = resSubscription.data.data.invoices;
                    this.$events.$emit('pageLoaded');
                }), () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

    },

}

</script>